/** Internal catalog PDF path (proxied to static origin via next.config rewrites). */
export const CATALOG_PDF_PATH = "/catalog.pdf";
